//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './TransportClientClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetTransportClientQueryParameters = {
  protocol: Types.TransportProtocol ;
}

export type UpdateTransportClientQueryParameters = {
  protocol: Types.TransportProtocol ;
  direction: Types.TransportMessageDirection ;
}

export function getUrl(protocol: Types.TransportProtocol): string {
  let url_ = getBaseUrl() + "/api/transport-clients/{protocol}";
if (protocol === undefined || protocol === null)
  throw new Error("The parameter 'protocol' must be defined.");
url_ = url_.replace("{protocol}", encodeURIComponent("" + protocol));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.TransportClientDto[], unknown, Types.TransportClientDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.TransportClientDto[], unknown, Types.TransportClientDto[]>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(protocol: Types.TransportProtocol): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { protocol,  } = params[0] as GetTransportClientQueryParameters;

    return trimArrayEnd([
        'TransportClientClient',
        'get',
        protocol as any,
      ]);
  } else {
    return trimArrayEnd([
        'TransportClientClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as Types.TransportProtocol,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.TransportClientDto[], TError = unknown>(dto: GetTransportClientQueryParameters, options?: Omit<UseQueryOptions<Types.TransportClientDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets clients.
 */
export function useGetQuery<TSelectData = Types.TransportClientDto[], TError = unknown>(protocol: Types.TransportProtocol, options?: Omit<UseQueryOptions<Types.TransportClientDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.TransportClientDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.TransportClientDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let protocol: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ protocol,  } = params[0] as GetTransportClientQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [protocol, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.TransportClientDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(protocol),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.TransportClientDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets clients.
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.TransportClientDto[] | undefined) => Types.TransportClientDto[], protocol: Types.TransportProtocol) {
  queryClient.setQueryData(getQueryKey(protocol),
    updater
  );
}

/**
 * Gets clients.
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.TransportClientDto[] | undefined) => Types.TransportClientDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function updateUrl(protocol: Types.TransportProtocol, direction: Types.TransportMessageDirection): string {
  let url_ = getBaseUrl() + "/api/transport-clients/{protocol}/{direction}";
if (protocol === undefined || protocol === null)
  throw new Error("The parameter 'protocol' must be defined.");
url_ = url_.replace("{protocol}", encodeURIComponent("" + protocol));
if (direction === undefined || direction === null)
  throw new Error("The parameter 'direction' must be defined.");
url_ = url_.replace("{direction}", encodeURIComponent("" + direction));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateMutationKey(protocol: Types.TransportProtocol, direction: Types.TransportMessageDirection): MutationKey {
  return trimArrayEnd([
      'TransportClientClient',
      'update',
      protocol as any,
      direction as any,
    ]);
}

/**
 * Updates the time when transporter was active
 */
export function useUpdateMutation<TContext>(protocol: Types.TransportProtocol, direction: Types.TransportMessageDirection, options?: Omit<UseMutationOptions<Types.TransportClientDto, unknown, Types.TransportClientDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.TransportClientDto, unknown, Types.TransportClientDto, TContext> {
  const key = updateMutationKey(protocol, direction);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.TransportClientDto) => Client.update(protocol, direction, dto),
    mutationKey: key,
  });
}
  
type Update__MutationParameters = UpdateTransportClientQueryParameters & {
  dto: Types.TransportClientDto;
}

/**
 * Updates the time when transporter was active
 */
export function useUpdateMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.TransportClientDto, unknown, Update__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: UpdateTransportClientQueryParameters}): UseMutationResult<Types.TransportClientDto, unknown, Update__MutationParameters, TContext> {
  const key = updateMutationKey(options?.parameters?.protocol!, options?.parameters?.direction!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Update__MutationParameters) => Client.update(data.protocol ?? options?.parameters?.protocol!, data.direction ?? options?.parameters?.direction!, data.dto),
  mutationKey: key,
});
}